'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConnectors = undefined;

var _dataLayer = require('./dataLayer');

var _inhouse_analytics = require('./inhouse_analytics');

var getConnectors = exports.getConnectors = function getConnectors(_ref) {
  var sendInHouseAnalytics = _ref.sendInHouseAnalytics;

  var connectorList = [(0, _dataLayer.dataLayerConnectorFactory)(), (0, _inhouse_analytics.inHouseAnalyticsConnectorFactory)({ sendInHouseAnalytics: sendInHouseAnalytics })];

  return {
    send: function send() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      return connectorList.forEach(function (conn) {
        return conn.send.apply(conn, data);
      });
    },
    setCustomDimension: function setCustomDimension() {
      for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        data[_key2] = arguments[_key2];
      }

      return connectorList.forEach(function (conn) {
        return conn.setCustomDimension.apply(conn, data);
      });
    },
    flush: function flush() {
      return connectorList.map(function (conn) {
        return conn.flush();
      }).filter(Boolean).join('');
    }
  };
};

exports.default = {
  getConnectors: getConnectors
};
//# sourceMappingURL=index.js.map